import { useGetCustomEmails } from "features/Integration/utils/apiCalls/useCustomEmails";
import { useEmailSenderStore } from "../store/useEmailSenderStore";
import { useEffect } from "react";

export const useFetchEmailDetails = () => {
  const setCustomDomain = useEmailSenderStore((state) => state.setCustomDomain);
  const setEmailSenderList = useEmailSenderStore(
    (state) => state.setEmailSenderList
  );
  const setDefaultConfigEmail = useEmailSenderStore(
    (state) => state.setDefaultConfigEmail
  );
  const setDefaultConfigNumber = useEmailSenderStore(
    (state) => state.setDefaultConfigNumber
  );

  const { data, isSuccess, isFetching: isLoading } = useGetCustomEmails();

  useEffect(() => {
    if (isSuccess && data) {
      setCustomDomain(data.email_custom_domain);
      setEmailSenderList(data.custom_email_sender_list ?? []);
      setDefaultConfigEmail(data.default_config.email);
      setDefaultConfigNumber(data.default_config.number);
    }
  }, [data, isSuccess, isLoading]);

  return {
    isLoading,
  };
};
